const isFormData = (body) => typeof FormData !== "undefined" && body instanceof FormData;

export async function requestJson(url, options = {}) {
    const { body, headers, ...rest } = options;
    const requestOptions = { ...rest };

    if (body !== undefined) {
        requestOptions.body = isFormData(body) || typeof body === "string"
            ? body
            : JSON.stringify(body);
    }

    requestOptions.headers = isFormData(body)
        ? headers
        : {
            "Content-Type": "application/json",
            ...(headers || {})
        };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
        const text = await response.text().catch(() => "");
        throw new Error(text || `Ошибка сервера: ${response.status}`);
    }

    if (response.status === 204) {
        return null;
    }

    return response.json();
}

export function toArray(value) {
    return Array.isArray(value) ? value : [];
}
